import React from "react";
import {Button} from "reactstrap";
import {TextField} from "@material-ui/core";

// noinspection JSUnresolvedVariable
/**
 * @param {Inventories_Properties} product
 * @param remove
 */
export default ({product, remove}) => {
	const name = product.skus?.name ?? product.name ?? 'N/A';
	const quantity = product.quantity ?? 1;
	const catalogPrice =
		product.price != null && product.price !== ''
			? product.price
			: product.skus?.price_retail != null && product.skus?.price_retail !== ''
				? product.skus.price_retail
				: null;

	return (
	<div
		key={product.pkey}
		className="form-group"
		style={{
			backgroundColor: "#f9f9f9",
			paddingTop: "4px",
			paddingBottom: "4px",
			paddingLeft: "8px",
			marginBottom: "8px",
			fontSize: "14px",
			borderRadius: "3px !important",
			border: "1px solid #efefef",
		}}
	>
		{name}
		{catalogPrice != null ? (
			<> - ${parseFloat(catalogPrice).toFixed(2)}</>
		) : null}
		<span>&nbsp;&nbsp;x&nbsp;&nbsp;</span>
		{quantity}
		<Button
			id={product.pkey}
			color={"danger"}
			size={"sm"}
			style={{lineHeight: "1", marginRight: "1px", marginTop: "-3px"}}
			className={"pull-right"}
			onClick={remove}
		>
			<i className={"fa fa-times"}/>
		</Button>
	</div>
	);
};
